<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>ユーザー新規登録</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">キャンセルする</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="register">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>ID</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="32" v-model="user.userCode" class="form-control" autocomplete="off" placeholder="ユーザーID（必須）" required >
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>名称</label>
              </div>
              <div class="col-4">
                <input type="text" maxlength="30" v-model="user.familyName" class="form-control" autocomplete="off" placeholder="姓（必須）" required>
              </div>
              <div class="col-5">
                <input type="text" maxlength="30" v-model="user.givenName" class="form-control" autocomplete="off" placeholder="名（必須）" required>
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>ふりがな</label>
              </div>
              <div class="col-4">
                <input type="text"
                maxlength="60" v-model="user.familyKana" class="form-control" autocomplete="off" placeholder="せい（必須）" required>
              </div>
              <div class="col-5">
                <input type="text"
                maxlength="60" v-model="user.givenKana" class="form-control" autocomplete="off" placeholder="めい（必須）" required> 
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>パスワード</label>
              </div>
              <div class="col-9">
                <input type="password" maxlength="24" v-model="user.password" class="form-control" autocomplete="off" placeholder="パスワード（必須）" required>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
              </div>
                <div class="col-9">
                  <input name="isTemporaryPassword" id="isTemporaryPassword" type="checkbox" v-model="user.isTemporaryPassword">
                  <label for="isTemporaryPasswordOn" class="checkbox">ユーザーにパスワードの変更を求める</label><br>
                </div>
            </div>
          </div>
          <div class="form-group" v-if="isProfession">
            <div class="row">
              <div class="col-3">
                <label>職種</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="user.profession" required @change="professionChanged">
                  <option value=""></option>
                  <option value="1">医師</option>
                  <option value="8">麻酔科</option>
                  <option value="6">看護役職</option>
                  <option value="2">看護師</option>
                  <option value="5">看護補助</option>
                  <option value="4">薬剤師</option>
                  <option value="9">放射線技師</option>
                  <option value="10">臨床検査技師</option>
                  <option value="7">検査科</option>
                  <option value="11">保育士</option>
                  <option value="12">保育補助</option>
                  <option value="13">理学療法士</option>
                  <option value="14">管理栄養士</option>
                  <option value="15">社会福祉士</option>
                  <option value="16">救急救命士</option>
                  <option value="3">事務</option>
                  <option value="0">その他</option>
                </select>
              </div>
            </div>  
          </div>
          <div class="form-group" v-if="isProfessionText">
            <div class="row">
              <div class="col-3">
                <label>職種名称</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="40" v-model="user.professionText" class="form-control" autocomplete="off" placeholder="職種名称">
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>所属 (組織)</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="user.organizationId">
                  <option v-for="option in organizationOptions" v-bind:value="option.id" v-bind:key="option.id">
                    {{ option.displayName }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>肩書</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="40" v-model="user.description" class="form-control" autocomplete="off" placeholder="肩書">
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>管理サイト権限</label>
              </div>
              <div class="col-9">
                <input name="privilege" id="member1" type="radio" value="1" v-model="user.privilege" required>
                <label for="member1" class="radio_label">使用不可</label><br>
                <input name="privilege" id="member2" type="radio" value="2" v-model="user.privilege">
                <label for="member2" class="radio_label">管理者</label><br>
                <input name="privilege" id="member3" type="radio" value="3" v-model="user.privilege">
                <label for="member3" class="radio_label">参照のみ</label><br>
                <input name="privilege" id="member9" type="radio" value="9" v-model="user.privilege" v-if="isSuper">
                <label for="member9" class="radio_label" v-if="isSuper">システム管理権限</label>
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>追加機能権限</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="user.roleId">
                  <option v-for="role in roles" v-bind:value="role.id" v-bind:key="role.id">
                    {{ role.roleName }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <!-- <div class="form-group" v-if="isMediApo">
            <div class="row">
              <div class="col-3">
                <label>メディ・アポ</label>
              </div>
              <div class="col-9">
                <input name="appointmentUser" id="mediappoOn" type="radio" value="1" v-model="user.appointmentUser" required>
                <label for="mediappoOn" class="radio_label">使用する</label><br>
                <input name="appointmentUser" id="mediappoOff" type="radio" value="0" v-model="user.appointmentUser">
                <label for="mediappoOff" class="radio_label">使用しない</label><br>
              </div>
            </div>
          </div> -->
          <div class="form-group" v-if="isSuper && this.$store.getters.hospital.isConference">
            <div class="row">
              <div class="col-3">
                <label>ビデオ通話カンファレンス</label>
              </div>
              <div class="col-9">
                <input name="isUseConference" id="conferenceOn" type="radio" value="1" v-model="user.isUseConference" required>
                <label for="conferenceOn" class="radio_label">使用する</label><br>
                <input name="isUseConference" id="conferenceOff" type="radio" value="0" v-model="user.isUseConference">
                <label for="conferenceOff" class="radio_label">使用しない</label><br>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>共通連絡先の対象から外す</label>
              </div>
              <div class="col-2">
                <input type="checkbox" class="form-control" v-model="user.isExcluded">
              </div>
              <div class="col-7">
              </div>
            </div>  
          </div>
          <!-- <div class="form-group" v-if="isMediApo">
            <div class="row">
              <div class="col-3">
                <label>メールアドレス</label>
              </div>
              <div class="col-9">
                <input type="email" maxlength="256" v-model="user.email" class="form-control" autocomplete="off" placeholder="メールアドレス">
              </div>
            </div>
          </div> -->
          <button id="register_button" type="submit" class="btn btn-info btn btn-block">登録する</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Create',
  mixins: [sessions,path,headers],
  props: ['realms','serviceName'],
  data: function(){
    return {
      message: '',
      organizationOptions: [],
      roles:[],
      historyId: -1,
      privilege: 0,
      user: {
        hospitalId: '',
        userCode: '',
        userName: '',
        userKana: '',
        password: '',
        profession: '',
        professionText: '',
        organizationId: '',
        description: '',
        privilege: '1',
        roleId: '',
        isExcluded: false,
        isTemporaryPassword: false,
        familyName: '',
        givenName: '',
        familyKana: '',
        givenKana: '',
        email: '',
        appointmentUser: '0',
        isUseConference: '0',
      }
    }
  },
  created () {
    if (this.serviceName === 'SmartPhone'){
      this.user.profession = '0'
    }
  },
  computed: {
    isSuper: function () {
      return Number(this.privilege) === 9
    },
    isMessage: function () {
      return this.message.length > 0
    },
    // isMediApo: function (){
    //   return this.serviceName === 'Nichibyo'
    // },
    isProfession: function (){
      return this.serviceName === 'Nichibyo'
    },
    isProfessionText: function (){
      if (this.serviceName === 'Nichibyo'){
        return this.user.profession === '0'
      } else {
        return true
      }
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !== 0){
      this.init()
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.init()
        }
      }
    )
  },
  methods: {
    register() {
      if (this.user.familyName.startsWith("メンテナンスユーザー")) {
        this.message = "名称を変更してください"
        return
      }
      if (this.user.userCode.startsWith("maintenanceuser")) {
        this.message = "IDを変更してください"
        return
      }
      if (this.user.profession !== "0") this.user.professionText = null;
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          this.setName()
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          this.user.hospitalId = hospitalId
          const userData = this.setUserData();
          axios.post("/api/user", {
              user: userData
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              if (res.errorMessage.conferenceErrorMessage) {
                const errorMessage = `ユーザーの登録は完了しましたがカンファンレンスへのユーザー転記に失敗しました。失敗の理由を確認のうえユーザー変更画面より再度転記を試みてください。【失敗の理由】${res.errorMessage.conferenceErrorMessage}`;
                this.message = errorMessage;
              } else {
                this.message = res.errorMessage;
              }
            } else {
              alert('登録されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/user/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/user/index'))
    },
    init() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          this.getCurrent(session).then(() =>{
            this.getOrganization(session)
          }).then(() => {
            this.getRole(session)
          })
          var privilege = 0
          if(this.$cognito.isUseCognito){
            var idToken = session.getIdToken()
            privilege = idToken.payload['custom:privilege']
            if( privilege!== undefined) this.privilege = privilege
          } else {
            this.privilege = session.privilege
          }
        } else {
          //this.$router.replace('/login') 
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    getOrganization(session) {
      var accessToken = this.getAccessToken(this.$cognito,session)
      var hospitalId = this.$store.getters.hospital.id
      axios.post("/api/organization/management/belonglist",{
        hospitalId: hospitalId,
        historyId: this.historyId
      }, {
        headers: this.headers(accessToken)
      }).then(response => {
        this.organizationOptions = response.data.data.organizations
        if(this.organizationOptions.length > 0) {
          var selected = this.organizationOptions[0]
          this.user.organizationId = selected.id
        }
      }).catch(err => {
        throw err
      })
    },
    getCurrent(session) {
      if(this.$store.getters.organization){
        this.historyId = this.$store.getters.organization.historyId
        return Promise.resolve();
      } else {
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$store.getters.hospital.id
        return axios.get("/api/organization/management/current/" + hospitalId, {
          headers: this.headers(accessToken)
        }).then(response => {
          var data = response.data.data
          if(data){
            var organization = data.organization
            this.$store.commit('organization',{
                startAt: organization.startAt,
                historyId: organization.historyId
            })
            this.historyId = organization.historyId
          }
          return Promise.resolve();
        }).catch(err => {
          return Promise.resolve(err);
        })
      }
    },
    getRole(session){
      var accessToken = this.getAccessToken(this.$cognito,session)
      var hospitalId = this.$store.getters.hospital.id
      axios.get("/api/role/list/" + hospitalId,{
        headers: this.headers(accessToken)
      }).then(response => {
        this.roles = response.data.data.roles;
        this.roles.unshift({ id: null, roleName: null})
      }).catch(err => {
        throw err
      })
    },
    setName() {
      this.user.userName = this.user.familyName + ' ' + this.user.givenName
      this.user.userKana = this.user.familyKana + ' ' + this.user.givenKana
    },
    setUserData() {
      const user = {
        hospitalId: this.user.hospitalId,
        userCode: this.user.userCode,
        userName: this.user.userName,
        userKana: this.user.userKana,
        password: this.user.password,
        profession: this.user.profession,
        professionText: this.user.professionText,
        organizationId: this.user.organizationId,
        description: this.user.description,
        privilege: this.user.privilege,
        roleId: this.user.roleId,
        isExcluded: this.user.isExcluded,
        isTemporaryPassword: this.user.isTemporaryPassword,
        familyName: this.user.familyName,
        givenName: this.user.givenName,
        familyKana: this.user.familyKana,
        givenKana: this.user.givenKana,
        email: this.user.email,
        appointmentUser: this.user.appointmentUser,
        isUseConference: this.user.isUseConference === 1 || this.user.isUseConference === "1",
      }
      return user;
    },
    professionChanged() {
      this.user.professionText = null;
    }
  } 
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#backBtn {
  float:right;
}
#register_button {
  margin-top: 30px;
}
.radio_label {
  margin-left: 0.5rem;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>